import React from 'react';
import Proptypes from 'prop-types';
import logo from '../images/loader.gif';
import { Well } from 'react-bootstrap';

class Loading extends React.Component {
    render() {
        let message = "Loading...";
        if (this.props.message) {
            message = this.props.message;
        }
        return <div style={{ paddingTop: '10%', paddingRight: '20%', paddingBottom: '10%', paddingLeft: '20%', opacity:'0.7' }}>
            <Well>
                <img className='center-block' style={{ height: 50, width: 50 }} alt="" src={logo} />
                <div className='text-center'> <span>{message}</span></div>
            </Well>
        </div>
    }
}

Loading.proptypes = {
    /** Optional message rendered. By default: 'Loading...' */
    message: Proptypes.String
}
export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js